import { defineComponent, computed, getCurrentInstance } from "vue";
import PlayableHistoryExport from "@pt/components/playable-history-export.vue";
export default defineComponent({
    components: {
        PlayableHistoryExport: PlayableHistoryExport
    },
    props: {
        handlePreview: [
            Function
        ]
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var detailDialog = computed(function() {
            return store.state.creative.detail.detailDialog;
        });
        return {
            detailDialog: detailDialog
        };
    }
});
